<template>
  <div class="skeleton is-relative is-full-width has-background-white m-t-5">
    <SkeletonView :height="height" width="100%" />
  </div>
</template>

<script>
import SkeletonView from '@/modules/core/ui/components/wrappers/SkeletonView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'GoogleSlideEmbedSkeleton',
  components: { SkeletonView },
  props: {
    height: {
      type: [Number, String]
    }
  }
};
</script>

<style scoped>
.skeleton {
  z-index: var(--ce-z-index-modal);
}
</style>
